const AUTH_LOCAL_STORAGE_KEYS = [
  'token',
  'auth',
  'featureFlags',
  // Remove the legacy misspelled key as well.
  'featureFlagd',
];

export function clearAuthLocalStorage() {
  if (typeof window === 'undefined') return;

  AUTH_LOCAL_STORAGE_KEYS.forEach((key) => {
    window.localStorage.removeItem(key);
  });
}
